import React from 'react'
import { i18n } from 'react-i18n'

export default React.createClass({

	mixins: [i18n('guest/payCreditOrDebit')],

	propTypes: {
		label: React.PropTypes.string
	},

	getInitialState () {
		return {};
	},

	render () {

		let payCreditOrDebit = this.i18n('label.payCreditOrDebit')

		return (
			<div className="row" style={{ maxWidth:400, margin: '0 auto' }}>
				<div className="col-xs-12 col-sm-12 col-md-12" style={{ padding: 0}}>
					<h3 className="donate_credit_debit">{payCreditOrDebit}</h3>
				</div>
			</div>
		);
	}
});



/** WEBPACK FOOTER **
 ** ./guest/payCreditOrDebit.js
 **/